import { TFunction } from 'i18next';
import { object, string } from 'yup';

export const ProviderSettingsValidation = (t: TFunction) => {
  const MISSING_MESSAGE = t('app.form.validation.required');
  const MIN_MESSAGE = t('app.form.validation.min', { field: t('form.field.name'), min: 3 });
  return object({
    name: string().trim().required(MISSING_MESSAGE).min(3, MIN_MESSAGE),
  });
};
